/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Type of conditional rule.
 */
export enum FormElementRuleType {
    READ_ONLY = 'ReadOnly',
    HIDDEN = 'Hidden',
}
